export default "__VITE_ASSET__Hnpz$kKM__"